import { EntityDatePicker, FormItem } from '@app/components'

import { DynamicInputProps } from '../../types'

export const DFEntityDatePicker: React.FC<DynamicInputProps> = ({ field, disabled }) => {
  return (
    <FormItem label={field.label} name={field.name} rules={field.rules}>
      <EntityDatePicker
        name={field.name}
        placeholder={field.placeholder}
        style={{ width: '100%' }}
        format="YYYY/MM/DD"
        disabled={disabled || field.disabled}
      />
    </FormItem>
  )
}
